import { Box, ScrollView } from 'native-base'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import IntroSection1 from '../components/premium-1on1-consulting-service/IntroSection1'
import IntroSection3 from '../components/premium-1on1-consulting-service/IntroSection3'
import IntroSection5 from '../components/premium-1on1-consulting-service/IntroSection5'
import { useRef } from 'react'

const Screen = () => {
	const heroRef = useRef<HTMLDivElement>(null)

	return (
		<Box backgroundColor={'singletons.white'}>
			<Header heroRef={heroRef} />
			<Box
				position="absolute"
				h="300px"
				top="0"
				bgColor="singletons.black"
			/>
			<ScrollView bgColor="singletons.black">
				<IntroSection1 heroRef={heroRef} />
				<IntroSection3 />
				<IntroSection5 />
				<Footer />
			</ScrollView>
		</Box>
	)
}

export default Screen
